import { constants } from '@airtm/utils';

const { accountStatus } = constants;
const { PARTIAL } = accountStatus;

export default function isStatusPartial(userStatus?: string) {
  return userStatus === PARTIAL;
}
